import navItems from '@/navigation/vertical'
import {getUser, setUser} from "@/composables/useUser.js"

const convertNavToRouter = data => {
    return data.flatMap(item => {
        const toFields = []
        if (typeof item.to === 'object' && !Array.isArray(item.to)) {
            toFields.push(item.to)
        }
        if (item.children) {
            toFields.push(...convertNavToRouter(item.children))
        }

        return toFields
    })
}

export const setupGuards = router => {
    router.beforeEach(async (to, from) => {
        const listRouters = convertNavToRouter(navItems)

        const currentRouter = listRouters.find(item => item.name === to.name)

        if (to.meta.public) return

        const isLoggedIn = !!useCookie('accessToken').value

        if (to.meta.unauthenticatedOnly) {
            return isLoggedIn ? '/' : undefined
        }

        if (!isLoggedIn) {
            return {
                name: 'login',
                query: {
                    ...to.query,
                    to: to.path !== '/' && to.path !== '/login' ? to.path : undefined,
                },
            }
        }

        const {username} = getUser()
        if (!username && to.name !== 'login') {
            try {
                const data = await ApiService.post('/auth/verify', null)
                if (data?.code === 200) {
                    setUser(data.metadata)
                }
            } catch (error) {
                useCookie('accessToken').value = null

                setUser({
                    id: null,
                    user_id: null,
                    username: "",
                    name: "",
                    display_name: "",
                    email: "",
                    avatar: "",
                    apply_to: [],
                    roles: [],
                    permissions: [],
                })

                router.push('/login')
            }
        }

        if (!currentRouter) {
            return {
                name: 'error',
                params: {
                    pathMatch: ['404'],
                },
            }
        }

        const {permissions = []} = getUser()
        if (currentRouter.meta?.permissionId && !permissions.includes(currentRouter.meta.permissionId)) {
            return {name: 'not-authorized'}
        }
    })
}
